import Login from "../../views/auth/Login";
import UserType from "../../views/auth/UserType";
import ForgotPassword from "../../views/auth/ForgotPassword";
import ChangePassword from "../../views/auth/ChangePassword";
import Google2FA from "../../views/auth/Google2FA";

const routes = [
  {
    component: Login,
    exact: true,
    path: "/admin/login",
  },
  {
    component: Login,
    exact: true,
    path: "/admin/",
  },
  {
    component: Google2FA,
    exact: true,
    path: "/verify-pin/:user_id"
  },
  {
    component: UserType,
    exact: true,
    path: "/admin/user-type",
  },
  {
    component: ForgotPassword,
    exact: true,
    path: "/forgot-password",
  },
  {
    component: ChangePassword,
    exact: true,
    path: "/change-password/:token",
  }
];

export default routes;
